import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';

import { FileUpload } from '../../../FileUpload';
import { LabelName, Required } from '../../../../../utils';

export function FileUploadNormalView({
  data,
  setData,
  setError,
  ind,
  isRequired,
  handleOnFileUploadError = () => {},
  handleOnFileUploadLoading = () => {},
  globalStateData,
  setCustomFieldsValidation,
}) {
  const [value, setValue] = useState(globalStateData?.customFormData?.[ind]?.fieldValue ?? '');
  const [error1, setError1] = useState('');
  const isDisabled =
    globalStateData?.customFormData?.[ind]?.isEditable !== undefined
      ? !globalStateData?.customFormData?.[ind]?.isEditable
      : false;

  useEffect(() => {
    if (globalStateData?.customFormData?.[ind]?.fieldValue)
      setData(globalStateData?.customFormData?.[ind]?.fieldValue, ind);
  }, []);

  useEffect(() => {
    setError(null); // Reset error on value change
    setData(value?.data?.value ?? '', ind);
  }, [value]);

  return (
    <Grid container style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <Grid item>
        <LabelName>
          {data?.fieldName}
          {isRequired && <Required> *</Required>}
        </LabelName>
      </Grid>
      <Grid item>
        <FileUpload
          handleOnSuccess={(driveLink) => {
            setValue(driveLink);
          }}
          handleOnUploadError={handleOnFileUploadError}
          handleOnFileUploading={handleOnFileUploadLoading}
          uploadLocation="custom-file-upload"
          setError={setError1}
          fileValidationDetails={data}
          disabled={isDisabled}
          setCustomFieldsValidation={setCustomFieldsValidation}
        />
      </Grid>
      {error1 && <span style={{ color: 'red', fontSize: '0.9rem' }}>{error1}</span>}
    </Grid>
  );
}

export default FileUploadNormalView;
